// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__2aYj2","body":"Page_body__1h0cn"};